import CommonAPIS from '../../helpers/APIS/CommonApisSchema';

export const allAPIs = [...CommonAPIS];

export const FetchingKey = 'fetching';
export const DataKey = 'response';
export const ErrorKey = 'error';
export const ConnectivityKey = 'connectivity';
export const APIErrorStoreKey = 'error';
export const NotificationStoreKey = 'latest-notification-timestamp';
export const WarningKey = 'warnings';

// Use navigator.onLine directly instead of importing from callAPI
export const initialState = () => {
    let state = {
        [ConnectivityKey]: navigator.onLine,
        [APIErrorStoreKey]: null,
        [NotificationStoreKey]: -1
    };
    for (const api of allAPIs) {
        state = {
            ...state,
            [api.storeKey]: {
                [FetchingKey]: false,
                [DataKey]: null,
                [ErrorKey]: null
            }
        };
    }
    return state;
};
